import type { PortCallExternalTimestampFragment } from '../../graphql';
import { PortcallExternalTimestampType } from '../../graphql';

const DELIMITER = '____';
const MAGIC = 'eta-api';

export function encodeExternalSourceIntoSourcedFrom(
  externalUpdate: PortCallExternalTimestampFragment,
): string {
  return [MAGIC, externalUpdate.sourceName, externalUpdate.timestampType].join(
    DELIMITER,
  );
}
export function decodeSourcedFromIntoExternalSourceInfo(sourcedFrom: string) {
  const [magic, sourceName, timestampTypeUnchecked] =
    sourcedFrom.split(DELIMITER);

  if (magic !== MAGIC) {
    return null;
  }

  if (!sourceName) {
    return null;
  }

  const timestampType = {
    [PortcallExternalTimestampType.ESTIMATE]:
      PortcallExternalTimestampType.ESTIMATE,
    [PortcallExternalTimestampType.REQUESTED]:
      PortcallExternalTimestampType.REQUESTED,
    [PortcallExternalTimestampType.PLANNED]:
      PortcallExternalTimestampType.PLANNED,
    [PortcallExternalTimestampType.ACTUAL]:
      PortcallExternalTimestampType.ACTUAL,
  }[timestampTypeUnchecked];
  if (!timestampType) {
    return null;
  }

  return {
    name: `${sourceName}`,
    timestampType,
  };
}
